<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">नियम एवं शर्तें</span></h2>

    <h4>
      <strong><span style="font-size: 12pt">सामान्य नियम</span></strong>
    </h4>

    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            हमारी वेबसाइट केवल कानूनी आयु के व्यक्तियों के लिए प्रतिबंधित है, जैसा कि उस क्षेत्राधिकार में निर्धारित
            किया गया है जिसमें व्यक्ति रहता है।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            हमारी वेबसाइट के उपयोग करने वाले किसी भी उपयोगकर्ता द्वारा उपयोग किए गए किसी भी राष्ट्रीय कानून, संघीय कानून
            या अंतर्राष्ट्रीय कानून के लिए हमारी वेबसाइट कोई जिम्मेदारी नहीं रखती।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            उपयोगकर्ता अपने स्वयं की क्रिया के लिए जिम्मेदार हैं, और अपने देश के कानूनों (जिसमें राज्य के कानून या
            कानूनी मुद्दे) के अधीन हैं।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            सभी एजेंट अपने-अपने सदस्यों के खाते के लिए जिम्मेदार हैं, तथा जमा किए गए सभी पुष्टि किए गए दांव का सम्मान
            करना होगा।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            एजेंट हमारी वेबसाइट के भागीदार नहीं हैं। इसलिए, हमारी वेबसाइट खिलाड़ियों और एजेंटों के बीच किसी भी अंतर या
            विवाद के लिए जिम्मेदार नहीं है।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            उपयोगकर्ता नाम और पासवर्ड की गोपनीयता उपयोगकर्ता की जिम्मेदारी है। यदि उपयोगकर्ता का उपयोगकर्ता नाम और
            पासवर्ड चोरी हो जाता है या लीक हो जाता है, तो उपयोगकर्ता को तुरंत अपने एजेंट से संपर्क करना चाहिए। एजेंट
            उपयोगकर्ता का उपयोगकर्ता नाम और पासवर्ड बदल देगा।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            यदि उपयोगकर्ता नाम और पासवर्ड चोरी हो जाते हैं, तो उपयोगकर्ता अपने खाते के लिए जिम्मेदार होगा और प्रस्तुत
            सभी पुष्टि दांव का सम्मान करेगा।
          </span>
        </p>
      </li>
    </ol>

    <h4>
      <strong><span style="font-size: 12pt">गेमिंग नियम</span></strong>
    </h4>

    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">हमारी वेबसाइट द्वारा तय किए गए खेल परिणाम अंतिम और बाध्यकारी होंगे।</span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            विवाद के सभी मामलों में, हमारी वेबसाइट के प्रबंधन और खिलाड़ी दोनों को इस बात पर सहमत होना होगा कि हमारी
            वेबसाइट का लेनदेन लॉग विवाद का अंतिम निर्णायक होगा। सभी विवादों को परिणाम तय होने के दिन तक दर्ज किया जाना
            चाहिए। मैच के बाद के दिन, कोई दावा स्वीकार नहीं किया जाएगा।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">खिलाड़ी अपने खाते के सभी लेनदेन की सटीकता की जांच के लिए स्वयं जिम्मेदार
            हैं।</span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            दांव लगाने से पहले आपको यह सुनिश्चित करना चाहिए कि आपके दांव में कोई गलती, त्रुटि या चूक नहीं है। एक बार
            कंप्यूटर द्वारा दांव स्वीकार कर लिया गया तो उसे बदला या रद्द नहीं किया जा सकता।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            हम किसी भी ऐसे खाते को फ्रीज या रद्द करने का अधिकार रखते हैं जो इन नियमों का उल्लंघन करता है, धोखाधड़ी में
            शामिल है, अनधिकृत गतिविधि, हमला, हैकिंग, जालसाजी, मानक नियमों को नुकसान पहुंचाने, या सिंडिकेट बेटिंग में
            शामिल है। ऐसे सभी खातों की शेष राशि जब्त कर ली जाएगी, बिना किसी पूर्व सूचना के।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            हम किसी भी ऐसे दांव या बेटिंग टिकट को अमान्य या रद्द करने का अधिकार सुरक्षित रखते हैं, जो सिंडिकेट बेटिंग,
            समन्वित बेटिंग, मिलीभगत, धोखाधड़ी, सिस्टम के दुरुपयोग, तकनीकी त्रुटियों या गलत ऑड्स का लाभ उठाने, या अनुचित
            लाभ प्राप्त करने के किसी अन्य प्रयास से संबंधित पाया जाता है। इससे संबंधित किसी भी जीत की राशि को वापस लिया
            जा सकता है, और संबंधित खाते को निलंबित या बंद किया जा सकता है।
          </span>
        </p>
      </li>
    </ol>

    <h4>
      <strong><span style="font-size: 12pt">सीमाएँ और दायित्व</span></strong>
    </h4>

    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            पूर्वनिर्धारित की व्याख्या पर प्रतिकूल प्रभाव डाले बिना, हमारी वेबसाइट किसी भी व्यक्ति के लिए किसी भी
            तोड़फोड़, अप्रत्याशित घटना, आग, बाढ़, विस्फोट, बिजली कटौती, संचार विफलता, या किसी अन्य तकनीकी समस्या के कारण
            किसी भी देरी, नुकसान, त्रुटि या किसी भी अन्य होने वाली घटना के लिए उत्तरदायी नहीं होगी।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            हमारी वेबसाइट किसी प्राकृतिक आपदा, बाढ़, आग, नागरिक अशांति, आतंकवादी गतिविधि, सरकारी आदेश या प्रतिबंध के लिए
            जिम्मेदार नहीं होगी।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            नेटवर्क कनेक्शन, संचार, सिस्टम या मानव त्रुटियों के कारण होने वाली किसी भी बेटिंग समस्या के मामलों में, जैसे
            दोहरी बेटिंग, बेट कन्फ़र्म न होना, या गेम शुरू होने के बाद बेट लगना — ऐसे मामलों में हम स्थिति के अनुसार
            कार्रवाई करेंगे, और किसी भी प्रकार की देनदारी नहीं लेंगे। यदि यह त्रुटि दोबारा होती है और आप बिना रिपोर्ट
            किए बेट लगाते रहते हैं, तो सभी जीत/हार के लिए आप जिम्मेदार होंगे।
          </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt"> ये नियम और विनियम दोनों पक्षों के बीच पूर्ण समझौते का गठन करते हैं। </span>
        </p>
      </li>

      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">
            यदि इन नियमों के अंग्रेज़ी संस्करण और किसी अन्य भाषा संस्करण के बीच कोई अंतर मौजूद है, तो अंग्रेज़ी संस्करण
            को सही और मान्य माना जाएगा।
          </span>
        </p>
      </li>
    </ol>

    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
